import { call, put, takeEvery, select } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';
import { RootState } from '../reducers/rootReducer';
import { setLoading } from '../actions/loading.actions';
import { callAPI } from '../../utils';
import { handleApiErrors, catchApiErrors } from './utils';
import { SAGA_RESET_PICK_TOUR, BFF_V1, BFF_PICK_TOURS, RESET_PICK_TOUR_ERROR, PICKING_APIGEE_BASE_PATH } from '../../constants';
import { APIError, ConfigAuthValues } from '../../types';
import { APIPickTour } from './types';
import { resetActivePickTour, resetActivePickTourComplete } from '../actions/orders.actions';
import { createToast } from '../actions/toasts.actions';
import i18n from '../../i18n';

const callResetPickTour = (data: APIPickTour, configAuthValues: ConfigAuthValues) => {
  return callAPI({
    method: 'POST',
    url: `${configAuthValues.APIGEE_BASE_URL}${PICKING_APIGEE_BASE_PATH}${BFF_V1}${BFF_PICK_TOURS}/${data.pickTourID}/reassign?resetItems=false`,
    data,
  });
};

export function* runResetPickTourSaga(action: ReturnType<typeof resetActivePickTour>): Generator<any, void, any> {
  const configAuthValues: ConfigAuthValues = yield select((state: RootState) => state.config.authValues);
  const { pickTour, pickTourIndex } = action.payload;

  yield put(setLoading({ sagaName: SAGA_RESET_PICK_TOUR, isLoading: true }));
  try {
    const result = yield call(callResetPickTour, pickTour, configAuthValues);
    yield put(createToast({ type: 'success', message: i18n.t('RESET_PICK_TOUR_SUCCESS') }));
    yield put(resetActivePickTourComplete({ pickTour, pickTourIndex }));
    yield handleApiErrors(result?.data?.errors);
  } catch (error) {
    if ((error as any)?.response?.status === 500) {
      const resetPickTourError: APIError[] = [{ id: '', code: RESET_PICK_TOUR_ERROR, detail: JSON.stringify(error) }];
      yield handleApiErrors(resetPickTourError);
    } else {
      try {
        const url = `${PICKING_APIGEE_BASE_PATH}${BFF_V1}${BFF_PICK_TOURS}/${pickTour.pickTourID}/reassign?resetItems=false`;
        const method = 'POST';
        const config = configAuthValues;
        yield catchApiErrors(error as any, { url, method, data: pickTour, config, saga: SAGA_RESET_PICK_TOUR });
      } catch (_error) {
        yield catchApiErrors(error as any);
      }
    }
  } finally {
    yield put(setLoading({ sagaName: SAGA_RESET_PICK_TOUR, isLoading: false }));
  }
}

export default function* watchResetPickTour() {
  yield takeEvery(getType(resetActivePickTour), runResetPickTourSaga);
}
